import FiltersMixin from '@/Core/mixins/FiltersMixin'
import Master from '@/Modules/Masters/connections/api/Master'
import { FiltersName } from '@/Modules/Addresses/enums/Filters'
import * as _ from 'lodash-es'
import { Component, mixins, Watch } from 'types-vue'

const MASTER_SLUG = 'location-province'

@Component
export default class ProvinceFilter extends mixins(FiltersMixin) {
  

  /**
   * STATE
   */

  protected loading: boolean = true
  protected list: any[] = []
  protected selected: number = null
  protected options: any[] = []



  /**
   * METHODS
   */

  protected addQueryParam() {
    const codes = this.selected.toString()
    const name = this.$route.name
    const query = (codes.length) 
      ? {...this.$route.query, [FiltersName.Provincia]: codes }
      : _.omit(this.$route.query, [FiltersName.Provincia, FiltersName.Municipio]);
    
    if (!_.isEqual(query, this.$route.query))
      this.$router.push({ name, query })
  }

  protected setSelectedElementsByQueryParams() {
    const codes = +(this.$route.query[FiltersName.Provincia] as string)
    this.selected = codes
  }

  private async obtainList() {
    try {
      this.loading = true
      const result = await Master.getAllList(MASTER_SLUG)
      this.list = result.data
    } catch (error) {
      
    } finally {
      this.loading = false
    }
  }

  protected updateFilter(filter: string) {
    filter = filter.toLowerCase()
    this.options = this.list.filter(item => {
      return item.code.toLowerCase().includes(filter) 
          || item.description.toLowerCase().includes(filter)
    })
  }


  protected onFocus() {
    this.updateFilter('')
  }


  /**
   * WHATCHERS
   */
  @Watch(`$route.query.${FiltersName.Provincia}`, { immediate: true })
  protected onchangeQueryParam() {
    const haveQueryParam = !!this.$route.query[FiltersName.Provincia]
    if (haveQueryParam) this.setSelectedElementsByQueryParams()
  }


  @Watch('selected')
  protected onChangeSelected() {
    this.addQueryParam()
  }

  @Watch('list')
  protected onChangeList() {
    this.updateFilter('')
  }


  /**
   * VUE LIFE CYCLE
   */
  
  protected async created() {    
    await this.obtainList()
  }
}